import type {Dataset} from './types';
export function datasetFileName(dataset:Dataset){
 return dataset.source_filename?.trim() || dataset.original_name?.trim() || '未记录文件名';
}
export function datasetOption(dataset:Dataset){
 const name=datasetFileName(dataset);
 const version=dataset.version_label || dataset.original_name || dataset.id;
 const count=`${(dataset.summary.enabled_cases??0).toLocaleString()} 条`;
 return {value:dataset.id,label:`${name} · ${version} · ${count}`,title:`${name} · ${version}`,displayTitle:name,displayDescription:`${version} · ${count}`};
}
